<template>
  <div id="print-delivery-component">
    <spinner-overlay v-if="loading" />
    <print-container v-else :title="`Køreplan ${deliveryDate.format('DD-MM-YYYY')}`" style="padding-top: 0 !important;"
      :header_style="{ backgroundColor: '#b45f06', color: 'white', display: 'none' }">
      <div v-for="(dates, weekNumber) in ordersData" :key="weekNumber" class="week-block">
        <div v-for="(locations, deliveryDate) in dates" :key="deliveryDate" class="date-block">
          <div v-for="(locationData, location) in locations" :key="location" class="location-block">

            <div class="h3 title-header" :style="'background-color: #' + locationData.color + '; '">Afhentningsliste -
              {{
                location.split(' (')[0]
              }} - {{ formatDate(deliveryDate) }}</div>
            <div class="totals-header">
              <div>Total bestillinger: <span class="bolder-text">{{ getNumberOfOrders(locationData) }}</span></div>
              <div>Total kuverter: <span class="bolder-text">{{ getNumberOfPlaceSettings(locationData) }}</span></div>
            </div>
            <table class="orders-table" style="table-layout: fixed;">
              <thead>
                <tr class="table-header-row">
                  <th style="white-space: nowrap; width: 120px;">ANTAL:</th>
                  <th style="">
                    <div style="display: flex; justify-content: space-between;">
                      <span>
                        NAVN:
                      </span>
                      <span>
                        TLF. NR.:
                      </span>
                    </div>
                  </th>
                  <th style="white-space: nowrap; width: 160px;">ORDRE NR.:</th>
                </tr>
              </thead>

              <template v-for="(orderGroup, orderGroupKey) in locationData.orders" :key="orderGroupKey">
                <tbody>
                  <tr class="order-group-header-row">
                    <td colspan="3" style="white-space: nowrap;">{{ orderGroupKey }}</td>
                  </tr>
                </tbody>
                <template v-for="(order, orderKey) in orderGroup" :key="orderKey">
                  <tbody :class="order[5]['val'].length > 0 ? 'print-avoid-break-inside' : null">
                    <tr class="order-row" :style="order[5]['val'].length > 0 ? 'border:none' : null">
                      <td>{{ order[1]['val'] }}</td>
                      <td style="">
                        <div style="display: flex; justify-content: space-between; gap: 10px;">
                          <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex-grow: 1;">
                            {{ order[2]['val'] }}
                          </span>
                          <span style="flex-shrink: 0;">
                            {{ order[3]['val'] }}
                          </span>
                        </div>
                      </td>
                      <td>#{{ order[4]['val'] }}</td>
                    </tr>
                    <tr class="order-extra-row" v-for="(extra, extraKey) in order[5]['val']" :key="extraKey"
                      :class="extraKey + 1 === order[5]['val'].length ? 'table-row-border' : null">
                      <td>{{ extra['quantity'] }}</td>
                      <td colspan="2">{{ extra['extra_product_name'] }}</td>
                    </tr>
                  </tbody>
                </template>
                <tbody>
                  <tr class="order-group-footer">
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </template>

            </table>
          </div>
        </div>
      </div>
    </print-container>
  </div>
</template>

<script>
import axios from 'axios';
import * as moment from 'moment';
import { computed, ref } from 'vue';

import SpinnerOverlay from '@/components/SpinnerOverlay.vue';
import { Order } from '@/models/order';
import PrintContainer from '@/print/PrintContainer.vue';
import { useRouteDataStore } from '@/stores/route-data';

export default {
  components: { PrintContainer, SpinnerOverlay },
  props: [],
  setup(props) {
    const loading = ref(true);
    const routeDataStore = useRouteDataStore();
    const trips = ref([]);
    const ordersData = ref({});

    moment.locale('da');

    const date = computed(() => {
      return new URLSearchParams(window.location.search).get('date');
    });
    const status = computed(() => {
      console.log("status", new URLSearchParams(window.location.search).get('status'));
      return new URLSearchParams(window.location.search).get('status');
    });
    const productId = computed(() => {
      return new URLSearchParams(window.location.search).get('product_id');
    });
    const pickupLocationId = computed(() => {
      return new URLSearchParams(window.location.search).get('pickup_location_id');
    });

    const getNumberOfOrders = (locationData) => {
      return Object.values(locationData.orders).reduce((total, orderGroup) => {
        return total + orderGroup.length;
      }, 0);
    };

    const getNumberOfPlaceSettings = (locationData) => {
      return Object.values(locationData.orders).reduce((total, orderGroup) => {
        return total + orderGroup.reduce((sum, order) => sum + order[1]['val'], 0);
      }, 0);
    };

    const deliveryDate = moment(props.date);

    axios
      .get(`/order_management/orders/pick_up_deliveries_data?date=${date?.value}&status=${status?.value}&product_id=${productId?.value}&pickup_location_id=${pickupLocationId?.value}`)
      .then(response => {
        ordersData.value = response.data.orders_data;

      }).finally(() => {
        loading.value = false;
        setTimeout(window.print, 250);
      });


    function formatDate(date) {
      return moment(date).format('ddd. [d.] DD-MM-YYYY');
    }

    return {
      loading,
      deliveryDate,
      trips,
      ordersData,
      formatDate,
      // methods
      getNumberOfOrders,
      getNumberOfPlaceSettings,
      getRouteName: (routeLetter, index) => `${routeLetter}${index + 1}`,
      getDeliveryTypeName: (delivery_type) => delivery_type === 'cold' ? 'kold' : 'varm',
    };
  }
};
</script>
<style lang="scss">
$base-color: #000000;
$title-color: #FFFFFF;
$title-background-color: #B45F06;
$header-background-color: #F2F2F2;

$focus-color: #FF0000;
$cold-color: #1154CC;
$warm-color: #990000;
$break-color: #D27B09;
$arrival-color: #6CA74E;
$departure-color: #992167;
$pitstop-color: #FF00FF;

#print-delivery-component {
  color: $base-color;

  .title-header {
    background-color: $title-background-color;
    padding: 20px;
    font-size: 25px;
    font-weight: bolder;
    text-transform: uppercase;
    color: #fff;
    margin-bottom: 0;
    text-align: center;
  }

  .totals-header {
    display: flex;
    padding-top: 20px;
    font-size: 20px;
    font-weight: bold;
    color: $base-color;
    margin-top: 0;
    margin-bottom: 20px;

    div {
      flex: 1;
      text-align: center;
      text-transform: uppercase;
    }
  }

  >div {
    flex: 1;
  }

  .table-header-row {
    background: #434343;
    color: #fff
  }

  .orders-table {
    width: 100%;
  }

  .order-group-header-row {
    background: #efefef;
    border-bottom: 2px solid #000;
    text-transform: uppercase;
    font-weight: bold;

  }

  .order-row {
    border-bottom: 2px solid #000
  }

  .order-extra-row {
    font-weight: bold;
    background: #f7eaab;

    &.table-row-border {
      border-bottom: 2px solid #000
    }
  }

  .order-group-footer {
    height: 30px;
  }



  th,
  td {
    padding: 0.5rem 2rem;
  }
}

.bolder-text {
  font-weight: bolder;
}

.bottom-border {
  border-bottom: 1px solid $base-color !important;
}

hr {
  border-top: 2px solid $base-color !important;
  margin: 0 !important;
}

.title {
  color: $title-color;
}



.delivery-header {
  font-weight: bold;
  font-size: larger;

  >p {
    margin: 0;
  }
}

.route {
  &.header {
    font-weight: bolder;
    background-color: $header-background-color;
  }

  >.arrival {
    color: $arrival-color;
  }

  >.departure {
    color: $departure-color;
  }
}

.focus {
  color: $focus-color;
}

h1.route-title {
  margin: 0;
  @extend .bolder-text;
}

.text-align-center {
  text-align: center;
}

.text-align-end {
  text-align: end;
}
</style>
<style lang="scss" scoped>
.row {
  margin-left: -8px;
  margin-right: -8px;
}

@for $i from 1 through 12 {
  .col-#{$i} {
    padding-left: 8px;
    padding-right: 8px;
  }
}
</style>